/* eslint-disable @typescript-eslint/no-inferrable-types */
import { SmBaseEntity } from "src/modules/sm-base/shared/sm-base-entity.model";
import { Column, Entity, JoinColumn, ManyToOne, Unique } from "typeorm";
import { GgnWeightingSchoolCareer } from "./ggn-weighting-school-career.enum";
import { SchoolTypeSettings } from "./school-type-settings.entity";

@Entity()
@Unique("UQ_ggn_weighting_settings_grade_career_count", ["settings", "grade", "schoolCareer", "ggnCount"])
export class GgnWeighting extends SmBaseEntity {
    @ManyToOne(() => SchoolTypeSettings, (o: SchoolTypeSettings) => o.ggnWeightings, { onDelete: "CASCADE", nullable: false, orphanedRowAction: "delete" })
    @JoinColumn({foreignKeyConstraintName: "FK_ggn_weighting_settings"})
    settings: SchoolTypeSettings;

    @Column({default: 0})
    grade: number = 0;

    @Column({type: "int", default: GgnWeightingSchoolCareer.without})
    schoolCareer: GgnWeightingSchoolCareer = GgnWeightingSchoolCareer.without;

    @Column({default: 1})
    ggnCount: number = 1;

    @Column({type: "double precision", nullable: true})
    factor: number = null;

    constructor(grade: number = 0, schoolCareer: GgnWeightingSchoolCareer = GgnWeightingSchoolCareer.without, ggnCount: number = 1) {
        super();
        this.grade = grade;
        this.schoolCareer = schoolCareer;
        this.ggnCount = ggnCount;
    }
}